import React from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  FirmAnswers,
  FirmQuestion,
  NO,
  YES,
  questionsForScreen,
  toggleChoice,
} from "../firmQuestions";

const useStyles = makeStyles((theme) => ({
  block: {
    marginTop: theme.spacing(2),
  },
  question: {
    marginBottom: theme.spacing(2),
  },
  text: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },
  optional: {
    color: theme.palette.text.secondary,
    display: "block",
    marginBottom: theme.spacing(1),
  },
}));

interface Props {
  screen: string;
  taxPayerType: string;
  questions: FirmQuestion[];
  answers: FirmAnswers;
  onChange: (questionId: number, answer: string[]) => void;
}

const FirmQuestions = ({
  screen,
  taxPayerType,
  questions,
  answers,
  onChange,
}: Props) => {
  const classes = useStyles();
  const visible = questionsForScreen(questions || [], screen, taxPayerType);
  const answerOf = (id: number): string[] => (answers || {})[id] || [];

  if (visible.length === 0) {
    return null;
  }

  return (
    <Box className={classes.block} data-test-id={`firm-questions-${screen}`}>
      {visible.map((question) => {
        const answer = answerOf(question.id);
        return (
          <Box className={classes.question} key={question.id}>
            <Typography className={classes.text} variant="body2">
              {question.text}
            </Typography>
            <Typography className={classes.optional} variant="caption">
              Optional
            </Typography>

            {question.answer_type === "yes_no" ? (
              <RadioGroup
                onChange={(event) => onChange(question.id, [event.target.value])}
                row
                value={answer[0] || ""}
              >
                {[YES, NO].map((choice) => (
                  <FormControlLabel
                    control={<Radio color="primary" size="small" />}
                    key={choice}
                    label={choice}
                    value={choice}
                  />
                ))}
              </RadioGroup>
            ) : (
              question.options.map((option) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={answer.includes(option)}
                      color="primary"
                      onChange={() => onChange(question.id, toggleChoice(answer, option))}
                      size="small"
                    />
                  }
                  key={option}
                  label={option}
                />
              ))
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default FirmQuestions;
